<template>
  <div>

    <v-container fluid class="card-flex-toolbar noPadding" scrollable style="width:100%;">
      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">Accounts</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip left>
          <v-btn v-on:click.prevent="$router.push({ path: '/dashboard/addaccount' })"
                 slot="activator"
                 small
                 fab
                 flat
                 middle
                 right>
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <span>Add Account</span>
        </v-tooltip>

        <!--Speed Dial-->
        <v-speed-dial v-model="speedDial"
                      :direction="direction"
                      :transition="transition">
          <v-btn slot="activator"
                 v-model="speedDial"
                 flat
                 small
                 fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
            <v-icon>fas fa-times</v-icon>
          </v-btn>

          <!-- Search Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewSearch = !viewSearch"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-search</v-icon>
            </v-btn>
            <span>Search</span>
          </v-tooltip>
          <!--End Of Search Button-->
          <!-- Filter Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewFilter = !viewFilter"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-filter</v-icon>
            </v-btn>
            <span>Filter</span>
          </v-tooltip>
          <!-- End Of Filter Button -->

        </v-speed-dial>
        <!--End Of Speed Dial-->

      </v-toolbar>

      <!--Card Design-->

      <v-container fluid
                   style="min-height: 0;"
                   grid-list-lg
                   v-bind:class="{'padContent': !drawer}">
        <v-layout row wrap>

          <!--Search Box-->
          <template v-if="viewSearch && !viewFilter">
            <v-flex xs12>
              <v-text-field label="Search"
                            v-model="search"
                            append-icon="fas fa-search"
                            @change="getSearchItems"
                            @input="getSearchItems"></v-text-field>
            </v-flex>
          </template>
          <!--End Of Search Box-->

          <!--No Data Message-->
          <template v-if="itemsMinusDeleted.length === 0">
            <v-flex xs12>
              <v-card>
                <v-card-text class="text-xs-center">
                  <v-flex xs12>Sorry, There is currently no data to display here</v-flex>
                  <span><v-icon x-large>fas fa-frown</v-icon></span>
                </v-card-text>
              </v-card>
            </v-flex>
          </template>
          <!--End Of No Data Message-->

          <!-- Accounts -->

          <ListItem v-for="itemMinus in itemsMinusDeleted" v-bind:liItem="{type: 'account',data: itemMinus}" :key="itemMinus.id" ref="listItem" v-on:Edit="redirectToEditPage($event)" v-on:Delete="DeleteAccount($event)"></ListItem>

          <!-- End Of Accounts -->


        </v-layout>
      </v-container>

      <!--End Of Card Design-->
    </v-container>

    <!-- Delete Account Dialog Box -->
    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Delete</v-card-title>
          <v-card-text>Are you sure you want to delete <b>"{{deleteAccount.accountName}}"</b>?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="deleteDialog = false">No</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="DeleteAccountAccept()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End Of Delete Account Dialog Box -->

  </div>
</template>

<script>
  import listItem from '../reuseable/viewListItem/listItem.vue'

  export default {
    components: {
      'ListItem': listItem
    },
    props: ['drawer'],
    data() {
      return {
        direction: 'left',
        speedDial: false,
        transition: 'slide-y-reverse-transition',
        moreOptions: false,
        search: '',
        viewSearch: false,
        viewFilter: false,
        filterBy: {
          transactionType: 'None',
          budget: 'None',
          category: 'None',
          currency: 'None',
          paymentType: 'None',
          show: false
        },
        deleteDialog: false,
        deleteAccount: {
          id: '',
          accountName: '',
          accountType: '',
          accountDescription: '',
          accountCurrency: '',
          accountAmount: 0,
          objectState: ''
        },
        items: [],
        itemsMinusDeleted: []
      }
    },
    methods: {
      DeleteAccountAccept: function () {
        this.deleteDialog = false

        this.deleteAccount.objectState = "Delete"

        ///Remove item from items array
        this.removeDeletedAccountsFromItems()

        this.$store.commit('markAccountAsDeleted', this.deleteAccount)
        
      },
      DeleteAccount: function (item) {

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === item) {
            this.deleteAccount = this.items[i]
            break
          }
        }

        this.deleteDialog = true
      },
      redirectToEditPage: function (item) {
        this.$router.push({ path: '/dashboard/editaccount/' + item })
      },
      removeDeletedAccountsFromItems: function () {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].objectState === 'Delete') {
            this.items.splice(i, 1)
          }
        }

        this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items))
      },
      getSearchItems: function () {
        //Check if Search is empty
        if (this.search === '') {
          return
        }

        //Get All Items from item
        this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items))

        //Remove Transactions that does not meet search criteria 
        for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
          if (this.itemsMinusDeleted[i].accountName.indexOf(this.search) === -1) {
            this.itemsMinusDeleted.splice(i, 1);
          }
        }

      },
    },
    beforeMount() {
      this.items = JSON.parse(JSON.stringify(this.$store.state.Accounts))

      ///Remove deleted items from items array
      this.removeDeletedAccountsFromItems()
      
    }
   
  }
</script>



// WEBPACK FOOTER //
// src/components/account/ViewAccounts.vue